import { Group, ActionIcon, Image, Box } from '@mantine/core';
import { IconLogout, IconUserCircle } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import classes from './app-header.module.css';

import { saipolLogo } from '@assets';
import {
  AccountsSelector,
  ClauseCampaignsSelector,
  LangSelect,
  OrganisationSelector,
  TsrAILink,
} from '@ui';
import { Permission, usePermissions } from '@auth/data-access';

interface AppHeaderProps {
  logout: () => void;
}

export function AppHeader({ logout }: AppHeaderProps) {
  const { t } = useTranslation();
  const { can } = usePermissions();

  return (
    <Group className={classes.container} h="100%" justify="space-between">
      <Group h="100%">
        <Box className={classes.logoContainer}>
          <Image
            alt="Empreinte Logo"
            fit="contain"
            flex={1}
            h="100%"
            src={'/empreinte-logo.jpeg'}
          />
        </Box>
      </Group>
      <Group>
        {can(Permission.OrganisationSelector) && <OrganisationSelector />}
        {can(Permission.AccountsSelector) && <AccountsSelector />}
        <ClauseCampaignsSelector />
        {/* <CampaignSelect /> */}

        <Group visibleFrom="md">
          <LangSelect />
        </Group>
        <TsrAILink
          aria-label={t('app.nav.profile')}
          color="white"
          size={40}
          to="/profile"
          variant="subtle"
          visibleFrom="xs"
        >
          <IconUserCircle
            stroke={1.5}
            style={{ width: '100%', height: '100%' }}
          />
        </TsrAILink>
        <Group visibleFrom="md">
          <ActionIcon
            aria-label={t('auth.logout')}
            color="white"
            onClick={logout}
            size={40}
            variant="subtle"
          >
            <IconLogout
              stroke={1.5}
              style={{ width: '100%', height: '100%' }}
            />
          </ActionIcon>
        </Group>
      </Group>
    </Group>
  );
}

export default AppHeader;
